<script>
/**
 * Imports
 */
import SignupNavigation from "./../navigation/SignupNavigation.vue";
import SignupSections from "./../sections/SignupSections.vue";

/**
 * Component: Signup Form
 *
 * @author PH
 */
export default {
  computed: {
    currentSection: function() {
      let current = "";

      this.$store.getters.sections.forEach(section => {
        if (section.active) {
          current = section.id;
        }
      });

      return current;
    }
  },

  components: { SignupNavigation, SignupSections }
};
</script>

<template>
  <div class="signup-form">
    <header class="signup-form__header" :class="['signup-form__header--' + currentSection]">
      <signup-navigation></signup-navigation>
    </header>

    <main class="signup-form__content" :class="['signup-form__content--' + currentSection]">
      <signup-sections></signup-sections>
    </main>
  </div>
</template>
